import { translate } from 'App/Internationalization';
import BaseInput from 'shared/Forms/Inputs/BaseInput';
import React from 'react';

export default class InputAddressDesignation extends React.Component {
	render() {
		const placeholder = translate(
			'global.forms.inputs.address.street_address_2.placeholder'
		);

		return (
			<BaseInput
				autocomplete="address-line2"
				className={this.props.className}
				disabled={this.props.disabled}
				name={this.props.name}
				placeholder={placeholder}
				required={this.props.required}
				type="text"
			/>
		);
	}
}

InputAddressDesignation.defaultProps = {
	className: '',
	disabled: false,
	name: 'streetAddress2',
	required: false,
};
